import React, { forwardRef, useMemo } from "react";
import { useSelector } from "react-redux";
import { Avatar } from "@activecollab/components";
import PropTypes from "prop-types";
import { getUserById, makeAvatarUrlTemplateSelector } from "../../store/selectors/selector.users.jsx";

const AvatarContainer = forwardRef(({ id, size, className, name, email, ...rest }, ref) => {
  const user = useSelector((state) => getUserById(state, id));
  const getAvatarUrlTemplate = useMemo(() => makeAvatarUrlTemplateSelector(), []);
  const url = useSelector((state) =>
    getAvatarUrlTemplate(state, {
      size: size ?? ``,
      userId: user ? id : 0,
      userName: name,
      userEmail: user?.email ?? email,
      avatarVersion: user?.avatar_version,
    })
  );

  return (
    <Avatar
      {...rest}
      ref={ref}
      url={url}
      size={size}
      className={className}
    />
  );
});

AvatarContainer.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  email: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
};

AvatarContainer.defaultProps = {
  id: 0,
  name: "",
  email: "",
  size: 24,
  className: "",
};

AvatarContainer.displayName = "AvatarContainer";

export default AvatarContainer;
